// ==========================================================================
// Generated Link Token Storage
// ==========================================================================
// The PWA captures an acquisition slug from `?link=<slug>` on first load and
// persists it to localStorage. The slug then rides along on the OTP /
// magic-link verify request so the backend can attribute the registration to
// the originating click (first-touch attribution).
//
// HttpOnly cookies don't work here because the Laravel backend lives on a
// different origin than the Vercel-hosted PWA; localStorage is the simplest
// cross-origin-safe persistence with a 30-day-ish lifetime expectation.

const STORAGE_KEY = 'generated_link_token';

export function getGeneratedLinkToken(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    // Private browsing or storage disabled — silently no-op.
    return null;
  }
}

export function setGeneratedLinkToken(slug: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, slug);
  } catch {
    // ignore
  }
}

export function clearGeneratedLinkToken(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
